// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_ItemRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * One translatable key, in every language of the requested scope.
 *
 * `chave` IS the default text: translations-service keys everything off
 * `lines.default_val`, the pt-BR string that appears in the code, so the key of
 * an item and its default-language text are the same string by construction.
 *
 * `traducoes` carries what the user would SEE — a language with no translation
 * falls back to `chave` — and `faltantes` names the languages that are only
 * showing it because nothing was translated (empty, or equal to the key). The
 * default language is never listed there.
 *
 * Both fields are shape-erased maps/lists rather than nested rows: the keys are
 * language codes, which are data (a tenant may add one), not a schema.
 *
 * Assembled by libraries/traducoes/Traducoes_catalog.php.
 */
import { registerContract } from './validate'

export interface Traducoes_ItemRow {
pagina?: string
chave?: string
traducoes?: Record<string, string>
faltantes?: string[]
}

registerContract('Traducoes_ItemRow', {
  pagina:    { type: 'string',  required: false },
  chave:     { type: 'string',  required: false },
  traducoes: { type: 'object',  required: false },
  faltantes: { type: 'array',   required: false },
})
